import { AxiosResponse } from 'axios';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { UseMutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { RQ_GET_LIST_IMPORT_EXPORT_STATUS, callAll } from 'Utils';
import { importListEntries } from 'Services';
import useAlertBanner from 'Hooks/reduxHelperHooks/useAlertBanner';
import useImportExportSuccessAlert from 'Routes/ListManagement/routes/hooks/useImportExportSuccessAlert';

type HookArgs = {
    mutationOptions?: UseMutationOptions<AxiosResponse, unknown, unknown, unknown>;
};
const useImportListEntries = ({ mutationOptions }: HookArgs) => {
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    const { addAlert } = useAlertBanner();
    const showSuccessAlert = useImportExportSuccessAlert();
    const history = useHistory();
    const location = useLocation();

    // copy pasta from previous FileUploader/Bulk-Upload code. Determines list page route.
    const routeToGoTo = location.pathname.split('/').slice(0, 3).join('/');

    const defaultOnSuccessHanlder = () => {
        const currentLocation = window.location.pathname;
        if (currentLocation.endsWith('/import-entries')) {
            // if on import-entries screen go back to list page
            history.push(routeToGoTo);
        }

        const bannerTextMessage = t('Start List Import Success');
        const alertId = 'start-import-success';
        showSuccessAlert({ bannerTextMessage, alertId });
        queryClient.invalidateQueries([RQ_GET_LIST_IMPORT_EXPORT_STATUS]);
    };

    return useMutation(importListEntries, {
        onSuccess: callAll(defaultOnSuccessHanlder, mutationOptions?.onSuccess),
        onError: () => {
            const errorAlertStatus = t('Start List Import Error');
            addAlert({
                id: 'start-import-error',
                status: 'danger',
                content: errorAlertStatus
            });
        }
    });
};

export default useImportListEntries;
